import { ParseResult, Schema } from "effect";
import { Effect } from "effect";
import { countryLookup } from "./lookup";
export const CountryCodeAlpha3Schema = Schema.String.annotations({
    title: "Country Code ISO 3166",
    description: "ISO 3166 country code alpha 3, also used for apple storefront/territory",
    examples: [
        "AFG",
        "USA"
    ]
}).pipe(Schema.length(3), Schema.brand("@open-revenue/schema/CountryCodeISO3166-Alpha3"));
export const CountryCodeAlpha2Schema = Schema.String.annotations({
    title: "Country Code ISO 3166",
    description: "ISO 3166 country code, also used for apple storefront/territory",
    examples: [
        "AF",
        "US"
    ]
}).pipe(Schema.length(2), Schema.brand("@open-revenue/schema/CountryCodeISO3166-Alpha2"));
//variable to  use to lookup country code alpha 2 from alpha 3
// countryLookup
const threeToTwoLookup = Object.entries(countryLookup).reduce((acc, [key, value])=>{
    const val = value["Alpha-3 code"];
    acc[CountryCodeAlpha3Schema.make(val)] = CountryCodeAlpha2Schema.make(key);
    return acc;
}, {});
const CountryCodeAlpha2FromAlpha3 = Schema.transformOrFail(CountryCodeAlpha2Schema, Schema.String, {
    decode: (value)=>Effect.sync(()=>threeToTwoLookup[CountryCodeAlpha3Schema.make(value)]),
    encode: (value)=>Effect.fail(new ParseResult.Forbidden(Schema.String.ast, "", "Not allowed to encode"))
});
const CountryCode = {
    Alpha3: {
        Schema: CountryCodeAlpha3Schema,
        Type: CountryCodeAlpha3Schema.Type,
        make: (value)=>Schema.decode(CountryCodeAlpha3Schema)(value),
        USA: "USA"
    },
    Alpha2: {
        FromAlpha3: CountryCodeAlpha2FromAlpha3,
        Schema: CountryCodeAlpha2Schema,
        Type: CountryCodeAlpha2Schema.Type,
        make: (value)=>Schema.decode(CountryCodeAlpha2Schema)(value)
    }
};
export const Country = {
    Code: CountryCode
};
